export default __webpack_public_path__ + "static/media/id.5a305e94.svg";